export default "__VITE_ASSET__CcvEQb1M__"